var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hero',{attrs:{"title":"403","subtitle":"Accesso Negato","text":"Scusaci! Non sei autorizzato ad accedere a questa pagina."}})
}
var staticRenderFns = []

export { render, staticRenderFns }